import {gql} from "@apollo/client";
import {AccountType} from "graphql/types/AccountType";

export const GET_ACCOUNT_LISTING_FOR_PICKUP = gql`
    query GetAccountListingForPickup($warehouseId: Long!) {
        allAccounts: getAccountListingForPickup(warehouseId: $warehouseId) {
            id
            name
            countryCode
            phone
            email
            status
            role {
                name
            }
            createdAt
            updatedAt
        }
    }
`;

export interface GetAccountListingForPickupResponse {
    allAccounts: AccountType[];
}

